<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-6 wc-col__md-8">
      <OverviewSelfserviceShortcut
        v-if="showMobileSelfserviceShortcut"
        key="mobile-shortcut"
        class="mb-16 mt-8"
        initial-state="closed"
        :pulseDuration="1600"
        :pulseActiveDuration="16000"
      ></OverviewSelfserviceShortcut>
      <IdLevelBox></IdLevelBox>
      <QuoteList
        v-if="partnerProxyId && showQuotes()"
        :partner-proxy-id="partnerProxyId"
      ></QuoteList>
      <PolicyList v-if="partnerProxyId" :partner-proxy-id="partnerProxyId"></PolicyList>
    </div>
    <div class="wc-col wc-col__sm-6 wc-col__md-4">
      <OverviewSelfserviceShortcut
        v-if="showDesktopSelfserviceShortcut"
        key="desktop-shortcut"
        class="mb-16"
        initial-state="half-open"
      ></OverviewSelfserviceShortcut>
      <TeaserListOverview></TeaserListOverview>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue'
import { useWindowSize } from '@vueuse/core'
import TeaserListOverview from '@/componentsTenant/rahmen/TeaserListOverview.vue'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import PolicyList from '@/components/policy/PolicyList.vue'
import QuoteList from '@/components/quote/QuoteList.vue'
import IdLevelBox from '@/components/account-management/idlevelupgrade/IdLevelBox.vue'
import OverviewSelfserviceShortcut from '@/components/rahmen/OverviewSelfserviceShortcut.vue'
import { usePoliciesStore } from '@/stores/policiesStore'

const partnerProxyId = ref<string | null>(null)
const { width } = useWindowSize()

const policiesStore = usePoliciesStore()
const isTrue = (value: string | boolean) =>
  !!value && value.toString().toLowerCase() === 'true'
const mobileScreen = computed(() => width.value < 600)
const showMobileSelfserviceShortcut = computed(
  () =>
    mobileScreen.value &&
    isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.SHOW_OVERVIEW_SELFSERVICE_SHORTCUT_MOBILE)
)
const showDesktopSelfserviceShortcut = computed(
  () =>
    !mobileScreen.value &&
    isTrue(
      globalThis.ENV_CONFIG?.FEATURE_FLAGS.SHOW_OVERVIEW_SELFSERVICE_SHORTCUT_DESKTOP
    )
)

onBeforeMount(() => {
  partnerProxyId.value = getPartnerProxyId()

  // reset pre-selected policy id in store (in-memory, one-time) after navigating away
  policiesStore.setPreSelectedPolicyId('')
})

const showQuotes = () => isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.SHOW_QUOTES)
</script>
